import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { Typography, Button } from "@material-ui/core";
import SmsIcon from "@material-ui/icons/Sms";
import FolderIcon from "@material-ui/icons/Folder";
import { Root, User } from "../../styles";
import TimeStats from "../time-stats";
import Link from "../../../../components/plain-link";
import ProfilePicture from "../../../../components/profile-picture";
import useStyles from "./styles";

const GroupProfile = () => {
  const classes = useStyles();
  const { username } = useParams();
  const isMember = useSelector((state) => state.groupsBuddiesData.isMember);
  const profilePicture = useSelector(
    (state) => state.groupsBuddiesData.profilePicture
  );
  const displayName = useSelector(
    (state) => state.groupsBuddiesData.displayName
  );
  const description = useSelector(
    (state) => state.groupsBuddiesData.description
  );
  const studyTime = useSelector((state) => state.groupsBuddiesData.studyTime);
  const icons = [
    { icon: <SmsIcon />, link: "/", value: "Chat" },
    { icon: <FolderIcon />, link: "/", value: "Files" },
  ];

  return (
    <Root>
      <User>
        <ProfilePicture
          picturePath={profilePicture}
          className={classes.profilePicture}
        />
        <Typography variant="h1" className={classes.displayName}>
          Welcome to {displayName}
        </Typography>
        <Typography className={classes.username}>
          group id: {username}
        </Typography>
        <Typography className={classes.description}>{description}</Typography>
        {isMember ? (
          <div className={classes.groupStyle}>
            {icons.map((icon) => (
              <Link to={icon.link} className={classes.link}>
                <Button className={classes.iconStyle}>
                  {icon.icon} {icon.value}
                </Button>
              </Link>
            ))}
          </div>
        ) : (
          <Link to="/">
            <Button className={classes.request}>Request Buddy</Button>
          </Link>
        )}
      </User>
      <div className={classes.displayStats}>
        <TimeStats time={studyTime} />
      </div>
    </Root>
  );
};

export default GroupProfile;
